import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Memoria } from '../model/Memoria';
import { Mother } from '../model/Mother';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_MotherMemoria extends FuncionCompatilibidadBase<Mother, Memoria> {
  funciones = {
    socket: (mother: Mother, memoria: Memoria): Incompatibilities | null => {
      let tipo = memoria.$caracteristicas.tipo;
      return mother.$caracteristicas[tipo] ?
          null
        : {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `La mother no es compatible con la memoria ${tipo}`,
          };
    },
    sodimm: (mother: Mother, memoria: Memoria): Incompatibilities | null => {
      return mother.$caracteristicas.sodimm == memoria.$caracteristicas.sodimm ?
          null
        : {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `La mother no es compatible con memorias sodimm`,
          };
    },
  };
}
